//#region src/internal/tool-helpers/define.ts
function defineTool(config) {
	return config;
}

//#endregion
export { defineTool };
//# sourceMappingURL=define-SD6AQa4b.js.map